import { ColDef } from "ag-grid-community";
import { ColParams } from "src/app/shared/grid/ag-grid";
import { LinkCellComponent } from "src/app/shared/grid/link-cell.component";
import * as CDs from "src/app/utility/commonColDef";
import { PreprocessDateTime } from "src/app/utility/view-field-mapping";
import { agDateColumnFilter } from "src/app/utility/gridHelper";
import { Blueprint } from "../generated-models/Blueprint";
import { environment } from "src/environments/environment";

// Cell renderer params for ID link to details page
export const capacityBlueprintDetailsCellComponentParams = {
  target: "_blank",
  url: (params: ColParams<Blueprint, string>) => {
    if (!params.data) return '';
    const base = environment.isTestEnv ? 'https://msazure.visualstudio.com/One/_git/Azure-CIS-CapacityBlueprints-Test?path=/blueprints' : 'https://msazure.visualstudio.com/One/_git/Azure-CIS-CapacityBlueprints?path=/blueprints';
    return `${base}/${params.data.ServiceTreeId}/${params.data.Type}/${params.data.Name}.bicep`;
  },
};

// Custom column for Created Time (UTC)
const CreatedTimeUTC: ColDef = {
  headerName: "Created Time(UTC)",
  field: "CreatedTime",
  cellRenderer: (params) => PreprocessDateTime(params.value),
  filter: "agDateColumnFilter",
  filterParams: {
    comparator: (filterLocalDateAtMidnight, cellValue) => agDateColumnFilter(filterLocalDateAtMidnight, cellValue),
  },
};

// Custom column for blueprint source classification (Backfilled | UserDeclared)
const Source: ColDef = {
  headerName: "Source",
  field: "Source",
  filter: "agSetColumnFilter",
};

// Details link — routes to the blueprint details page which shows lineage info and version history.
const BlueprintName: ColDef = {
  ...CDs.Name,
  cellRenderer: LinkCellComponent,
  cellRendererParams: {
    target: "_blank",
    url: (params: ColParams<Blueprint, string>) => {
      if (!params.data) return null;
      const { ServiceTreeId, Type, Name } = params.data;
      return `/quota/capacity/blueprint/serviceTreeId/${encodeURIComponent(ServiceTreeId)}/type/${encodeURIComponent(Type)}/name/${encodeURIComponent(Name)}`;
    },
  },
};

// Deep link to the versioned Bicep source in Azure DevOps at this row's commit hash; text shows the first 8 chars.
const CommitHash: ColDef = {
  ...CDs.CommitHash,
  cellRenderer: LinkCellComponent,
  cellRendererParams: {
    target: "_blank",
    text: (params: ColParams<Blueprint, string>) =>
      params.data?.CommitHash ? String(params.data.CommitHash).substring(0, 8) : "",
    url: (params: ColParams<Blueprint, string>) => {
      if (!params.data?.CommitHash) return null;
      const repo = environment.isTestEnv ? "Azure-CIS-CapacityBlueprints-Test" : "Azure-CIS-CapacityBlueprints";
      return `https://msazure.visualstudio.com/One/_git/${repo}?path=/blueprints/${params.data.ServiceTreeId}/${params.data.Type}/${params.data.Name}.bicep&version=GC${params.data.CommitHash}`;
    },
  },
};

export const CapacityBlueprintColumnDefinition: ColDef[] = [
  CDs.ServiceTreeId,
  CDs.ServiceTeam,
  CDs.Type,
  BlueprintName,
  CommitHash,
  CreatedTimeUTC,
  CDs.OwningTeam,
  Source,
];
